









import { Component, Prop, Vue } from "@/shared/vuepack";
import BannerTable from "@/admin/components/partners/BannerTable.vue";
import { useUserStore } from "@/shared/store/user";
import { useBannerStore } from "@/shared/store/banner";

@Component ({
  components: {
    BannerTable
  }
})
export default class DefaultBanner extends Vue {
  @Prop() partnerId: number;
  userStore = useUserStore();
  bannerStore = useBannerStore();

  async mounted () {
    this.bannerStore.getDefaultPartnerBanners();
  }

  get defaultBanners () {
    return this.bannerStore.defaultBanners;
  }

  get isLoading () {
    return !this.bannerStore.isLoaded;
  }
}
